import { Dialog } from "@mui/material"
import closeMenu from '../../assets/closeMenu.svg';

export default function ConfirmationDialog({
    message=`Are you sure?`,
    open=false,
    onClose=()=>{},
    onOptionClick=()=>{},
    options=['YES','NO']
}){


    return <Dialog
    open={open}
    onClose={onClose}
    >
        <div className="bg-pri d-flex justify-content-end">
            <div  className="cursor-pointer"
                onClick={onClose}
            >
                <img
                    src={closeMenu}
                    alt='img'
                    className="m-2"
                    style={{filter:'saturate(0)invert(1)',width:'20px',cursor:'pointer'}}
                />
            </div>
        </div>
        <div className="px-5 pb-4">
            

            <p className="text-pri my-4" style={{fontSize:'18px',}}>
                {message}
            </p>

            <div className="d-flex gap-1 justify-content-center">
                {options.map((c,i) => 
                        <div className={` p-1 px-5 rounded
                                ${i?'  text-pri':'text-white bg-pri'}
                            `}
                            key={i}
                            style={{
                                border:'1px solid',cursor:'pointer'
                            }}
                            onClick={()=>{
                                onOptionClick(c,i)
                                onClose()
                            }}
                        >
                            {c}
                        </div>
                )}
            </div>
        </div>

</Dialog>
}